<template>
    <div class="order-create">
        <OrderComponent isCreate="true"></OrderComponent>
    </div>
</template>

<script>
    import OrderComponent from "./components/OrderComponent";
    export default {
        name: "OrderCreate",
        components: {
            OrderComponent
        },
        data(){
            return {

            }
        }
    }
</script>

<style scoped>

</style>
